import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions, JsonpModule, Jsonp  } from '@angular/http';
import { HttpClient } from "../shared/wrappers/HttpClient";
import { Observable } from "rxjs";

@Injectable()
export class CnpjService {

    constructor(private http: Http,
                private httpClient: HttpClient,
                private jsonp: Jsonp) { }

    url: string = 'https://www.receitaws.com.br/v1/cnpj';
    headers: Headers;
    options: RequestOptions;
    authToken: string = "c11c2a12fa0301afcedfe730c8ef96c70f26f847f54b33e8a6aa015ef63ab8b1";

    private getHeaders() {
        this.headers = new Headers({ 'Authorization': 'Bearer ' + this.authToken });
        this.headers.append('Content-Type', 'application/json');
        this.options = new RequestOptions({ headers: this.headers });
        return this.options;
    }

    async getCompanyData2(cnpj: String) {
        const headers = this.getHeaders();
        return this.http
          .get(this.url + '/' + cnpj, headers)
          .map((res: Response) => res.json())
          .toPromise()
          .catch((error: any) => error.json() || 'Server error');
    }

    // async getCompanyData(cnpj: String) {
    //     let apiURL = `https://www.receitaws.com.br/v1/cnpj/12302367000149&callback=JSONP_CALLBACK`;
    //     return this.jsonp.request(apiURL)
    //         .map((res: Response) => res.json())
    // }

}




// WEBPACK FOOTER //
// ./src/app/services/cnpj.service.ts